import { COVERGO_SAAS_PROD } from "../consts.js"

export const seyna = {
	// CoverGo PROD
	"seyna-dev-studio.quote.hk": {
		appConfig: { tenantId: "seyna_dev", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
